/**
 * SortDescendIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SortDescendIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m12.4 15.47 5-6.67A.5.5 0 0 0 17 8H7a.5.5 0 0 0-.4.8l5 6.67a.51.51 0 0 0 .8 0" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const SortDescendIcon = makeIcon('SortDescendIcon', SortDescendIconSvg)
